<template>
    <div class="col-md-12 px-0 py-0">
        <div>
            <div class="row">
                <div class="col-md-7">
                    <button
                        type="button"
                        @click="showBody(0)"
                        :class="[
                            'btn btn-outline-primary',
                            page == 0 ? 'active' : '',
                        ]"
                    >
                        &nbsp;Lista
                    </button>
                    <button
                        type="button"
                        @click="showBody(3)"
                        :class="[
                            'btn btn-outline-primary',
                            page == 3 ? 'active' : '',
                        ]"
                    >
                        &nbsp;Banner
                    </button>
                    <button
                        type="button"
                        @click="showBody(4)"
                        :class="[
                            'btn btn-outline-primary',
                            page == 4 ? 'active' : '',
                        ]"
                    >
                        &nbsp;SEO
                    </button>
                </div>
                <div class="col-md-5 text-right align-top text-success">
                    <span style="font-size: 20px">Categorías</span>
                </div>
            </div>

            <div>
                <contest-category-list-component
                    v-if="page == 0"
                    v-bind:model_id="model_id"
                    @change="callChangeList"
                ></contest-category-list-component>
                <contest-category-form-component
                    v-if="page == 2"
                    v-bind:parent_id="model_id"
                    v-bind:model_id="contest_category_id"
                ></contest-category-form-component>
                <contest-category-section-component
                    v-if="page == 3"
                    v-bind:model_id="model_id"
                ></contest-category-section-component>
                <seo-component
                    v-if="page == 4"
                    v-bind:url="'/api/seo/categorias'"
                    v-bind:parent_id="model_id"
                ></seo-component>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        model_id: Number,
    },
    data() {
        return {
            page: 0,
            contest_category_id: 0,
            componentKey: 1,
        };
    },
    methods: {
        showBody(value) {
            this.page = value;
            this.contest_category_id = 0;
        },
        callChangeCreate() {
            this.page = 0;
            this.contest_category_id = 0;
        },
        callChangeList(id) {
            this.contest_category_id = id;
            this.page = 2;
        },
    },
    mounted() {},
};
</script>
